module.exports = __webpack_public_path__ + "img/logo-ecommerce.a457f3c0.svg";